export const EVENT_TYPES = [
  { value: 1, label: "Общественное" },
  { value: 2, label: "День открытых дверей" },
  { value: 3, label: "День без турникета" },
];

export const ALL_EVENT_TYPE_IDS = EVENT_TYPES.map((t) => t.value);
